import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { IMAGE_CONSTANT, TEXT_CONSTANT } from '../../../../constants/app';
import Button from '../../../../ui-core/Button/Button';
import LazyImage from '../../../../ui-core/Image';

import './style.css';

const ReadyToExperience = ({ loading, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick(
        TEXT_CONSTANT.JOIN_THE_TEAM,
        'isSignup',
        TEXT_CONSTANT.READY_TO_EXPERIENCE,
      );
    }
  };
  return (
    <Row className="row-margin-zero ready-to-exp">
      <Col
        className="d-flex justify-content-center align-items-center experience-col"
        xs={12}
        lg={7}
      >
        <div className="experience-block">
          <h2>{TEXT_CONSTANT.READY_TO_EXPERIENCE}</h2>
          <h3>{'30 Days of Strength and Mobility!'}</h3>
          <p>{TEXT_CONSTANT.PUSH_NEW_POSSIBILITIES}</p>
          <Button
            class="sign-up-button-new d-inline-block mb-3 text-uppercase"
            isDisabled={loading}
            isLoading={loading}
            onClick={handleClick}
            text={TEXT_CONSTANT.JOIN_THE_TEAM}
          />
          <p className="assurance-para">{TEXT_CONSTANT.ASSURANCE_TEXT}</p>
        </div>
      </Col>
      <Col xs={12} lg={5}>
        <LazyImage
          className="w-100 h-100"
          errorSrc={IMAGE_CONSTANT.MoveToImproveNewWebp}
          placeholderSrc={IMAGE_CONSTANT.MoveToImproveNewLow}
          src={IMAGE_CONSTANT.MoveToImproveNew}
        />
      </Col>
    </Row>
  );
};

ReadyToExperience.propTypes = {
  loading: PropTypes.bool,
  onClick: PropTypes.func,
};

export default ReadyToExperience;
